import './style/index.less';
import PersonaCollect from './PersonaCollect';

export default PersonaCollect;
